import React, { FC } from "react"
import { getStyleOverridesClone } from "./DynamicContentMarkdown"
import CarrotMarkdown from "../../utils/CarrotMarkdown"
import { TwoColumnList } from "components/views/atoms/Atoms"

type CustomCoverageProps = {
  customCoverageText: string
}

const CustomCoverage: FC<CustomCoverageProps> = ({ customCoverageText }) => {
  if (!customCoverageText) {
    return null
  }

  const customCoverageStyleOverrides = getStyleOverridesClone()
  customCoverageStyleOverrides.ul = TwoColumnList
  customCoverageStyleOverrides.li = TwoColumnList.li

  return <CarrotMarkdown source={customCoverageText} styleOverrides={customCoverageStyleOverrides} />
}

export { CustomCoverage }
